import { useContext } from "react";
import { AppContext } from "../../Context";
import { Preloader } from "../Preloader";

export const ResumoOrcamentos = () => {   
    const {
        dto, 
        dtoLength,
    } = useContext(AppContext);

    return !dtoLength ? (
        <p>{dtoLength === null ? <Preloader></Preloader> : "Não há orçamento lançado"}</p>
      ) : (
        <table className="highlight">
            <thead>
                <tr>
                    <th rowSpan={2}>Tarefa</th>
                    <th colSpan={5} className="center">Preço R$</th>
                    <th rowSpan={2}>&nbsp;</th>
                </tr>
                <tr>                
                    <th>Menor</th>
                    <th>Médio</th>
                    <th>Maior</th>
                    <th>Desvio</th>
                    <th>Aprovado</th>
                </tr>
            </thead>
            <tbody>
                {dto.map(({idtarefa,tarefa,menorvalor,valormedio,maiorvalor,desviopadrao,valoraprovado,fornecedoraprovado})=>{
                    return(
                    <tr key={idtarefa} className={fornecedoraprovado!==""?"green-information":""}>
                        <td>{tarefa}</td>
                        <td>{menorvalor}</td>
                        <td>{valormedio}</td>
                        <td>{maiorvalor}</td>
                        <td>{desviopadrao}</td>
                        <td>{valoraprovado}</td>
                        <td>{fornecedoraprovado}</td>
                    </tr>)
                })}
            </tbody>
        </table>
    );
};
